import { render, staticRenderFns } from "./BuyerBankAddition.vue?vue&type=template&id=4dc3b6a5&"
import script from "./BuyerBankAddition.vue?vue&type=script&lang=js&"
export * from "./BuyerBankAddition.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports